import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReviewAddons from "../components/ReviewAddons";
import { loadBookingFlow } from "../utils/bookingFlowStorage";
import "../partyBossTheme.css";

/**
 * Step 4: review + customer details + Razorpay (full page, not modal).
 */
export default function ReviewPayPage() {
  const navigate = useNavigate();
  const draft = loadBookingFlow();

  let reviewBackPath = "/booknow/addons";
  try {
    reviewBackPath =
      sessionStorage.getItem("pb_review_back_path") || "/booknow/addons";
  } catch (_) {
    reviewBackPath = "/booknow/addons";
  }

  useEffect(() => {
    if (
      !draft?.slotId ||
      !draft?.eventId ||
      !draft?.personsCount ||
      !draft?.eventDate
    ) {
      navigate("/booknow", { replace: true });
    }
  }, [draft, navigate]);

  if (
    !draft?.slotId ||
    !draft?.eventId ||
    !draft?.personsCount ||
    !draft?.eventDate
  ) {
    return null;
  }

  const selectedValues = {
    eventDate: draft.eventDate,
    eventId: draft.eventId,
    personsCount: draft.personsCount,
    slotId: draft.slotId,
  };

  return (
    <ReviewAddons
      embed
      isShow
      selectedAddons={draft.selectedAddons || {}}
      totalCost={draft.reviewTotalCost ?? 0}
      selectedValues={selectedValues}
      closeReview={() => navigate(reviewBackPath)}
      nameOnCake={draft.nameOnCake || ""}
      restoredTheater={draft.selectedTheaterSnapshot}
      restoredSlot={draft.selectedTimeSnapshot}
      bookingName={draft.bookingName}
      whatsapp={draft.whatsapp}
      email={draft.email}
    />
  );
}
